import { useForm } from "../hook";
import Header from "../components/Header";
import FormMenu from "../components/Menu";
import Content from "./components/Content";
import Style from "../../../../screens/View/style";

const type = 'view';

export default function SettingsView({ mod = 'pme' }) {
  const { activeForm, activeFormKey, form, data, goToEdit, goToView } = useForm({ mod });

  return (
    <Style>
      <Header
        mod={mod}
        goToEdit={goToEdit}
        goToView={goToView}
        type={type}
      />
      <div className="view-content">
        <FormMenu activeFormKey={activeFormKey} form={form} />
        <Content activeForm={activeForm} data={data} />
      </div>
    </Style>
  );
}
